import api from 'api';
import Location, { Locations } from 'records/Location';


export const LOCATIONS_ASYNC_ACTION_START = 'LOCATIONS_ASYNC_ACTION_START';
export const LOCATIONS_ASYNC_ACTION_ERROR = 'LOCATIONS_ASYNC_ACTION_ERROR';
export const LOCATIONS_ASYNC_UPDATE_SUCCESS = 'LOCATIONS_ASYNC_UPDATE_SUCCESS';
export const LOCATIONS_RESET_STATE = 'LOCATIONS_RESET_STATE';

function locationsAsyncStart() {
  return {
    type: LOCATIONS_ASYNC_ACTION_START,
  };
}

function locationsAsyncUpdateSuccess(data) {
  return {
    type: LOCATIONS_ASYNC_UPDATE_SUCCESS,
    data,
  };
}

function locationsAsyncError(error) {
  return {
    type: LOCATIONS_ASYNC_ACTION_ERROR,
    error,
  };
}

export function resetLocationsState() {
  return {
    type: LOCATIONS_RESET_STATE,
  };
}

export function getLocationsAsync() {
  return (dispatch, getState) => {
    dispatch(locationsAsyncStart());
    return api.request('location', 'get')
    .then((data) => {
      dispatch(locationsAsyncUpdateSuccess(data));
      return Location.getDefaultLocation(Locations(data));
    })
    .catch((err) => {
      dispatch(locationsAsyncError('Unable to get locations'));
      throw (err);
    });
  };
}
